/*
  Taken from https://ghe.spotify.net/encore/web/blob/master/src/core/hooks/useA11yDropdown.tsx
 */
import React, { useEffect, useState } from 'react';

export function useA11yDropdown({
  dropdownListId,
  triggerId,
  initialShow = false,
  initialSelected = 0,
}: {
  dropdownListId: string;
  triggerId: string;
  initialShow?: boolean;
  initialSelected?: number;
}) {
  const [show, setShow] = useState(initialShow);
  const [selected, setSelected] = useState(initialSelected);

  useEffect(() => {
    if (show) {
      const element = document.getElementById(dropdownListId) as HTMLElement;
      element.focus();
    }
  });

  const onClick = (e: React.MouseEvent, index: number) => {
    e.preventDefault();
    setShow(!show);
    setSelected(index);
  };

  const onHide = () => {
    setShow(false);
    const element = document.getElementById(triggerId) as HTMLElement;
    element.focus();
  };

  return { show, setShow, selected, setSelected, onClick, onHide };
}
